import Http from '@/services/httpAcademy'

export const listCoupons = (params) => Http.get('/admin/academy/coupons', { params })
